import {
  CREATE_AUTOMATION_SETTINGS_FAIL,
  CREATE_AUTOMATION_SETTINGS_REQ,
  CREATE_AUTOMATION_SETTINGS_RESET,
  CREATE_AUTOMATION_SETTINGS_SUCCESS,
  DELETE_AUTOMATION_SETTINGS_FAIL,
  DELETE_AUTOMATION_SETTINGS_REQ,
  DELETE_AUTOMATION_SETTINGS_SUCCESS,
  GET_AUTOMATION_SETTINGS_FAIL,
  GET_AUTOMATION_SETTINGS_REQ,
  GET_AUTOMATION_SETTINGS_SUCCESS,
  UPDATE_ACTIVATE_AUTOMATION_SETTINGS_FAIL,
  UPDATE_ACTIVATE_AUTOMATION_SETTINGS_REQ,
  UPDATE_ACTIVATE_AUTOMATION_SETTINGS_SUCCESS,
  UPDATE_AUTOMATION_SETTINGS_FAIL,
  UPDATE_AUTOMATION_SETTINGS_REQ,
  UPDATE_AUTOMATION_SETTINGS_RESET,
  UPDATE_AUTOMATION_SETTINGS_SUCCESS,
} from '../constants/automation';

export const automationSettingsReducer = (
  state = { automations: [], page: 1, totalPage: 0, leadsCount: 0 },
  action
) => {
  switch (action.type) {
    case GET_AUTOMATION_SETTINGS_REQ:
      return { loading: true };
    case GET_AUTOMATION_SETTINGS_SUCCESS:
      return {
        loading: false,
        automations: action.payload[0]?.data,
        page: action.payload[0]?.metadata[0]?.page || 1,
        totalPage:
          action.payload[0]?.metadata[0]?.total %
            action.payload[0]?.metadata[0]?.limit ===
          0
            ? action.payload[0]?.metadata[0]?.total /
              action.payload[0]?.metadata[0]?.limit
            : parseInt(
                action.payload[0]?.metadata[0]?.total /
                  action.payload[0]?.metadata[0]?.limit
              ) + 1,
      };
    case GET_AUTOMATION_SETTINGS_FAIL:
      return { loading: false, error: action.payload };
    case CREATE_AUTOMATION_SETTINGS_REQ:
      return { ...state, loading: true };
    case CREATE_AUTOMATION_SETTINGS_SUCCESS:
      return {
        loading: false,
        successCreate: true,
        automationCreate: action.payload?.automations,
        leadsCount: action.payload?.leadsCount,
        automations: [...state.automations, action.payload?.automations].sort(
          function (a, b) {
            return new Date(b.createdAt) - new Date(a.createdAt);
          }
        ),
      };
    case CREATE_AUTOMATION_SETTINGS_FAIL:
      return { ...state, loading: false, error: action.payload };
    case CREATE_AUTOMATION_SETTINGS_RESET:
      return { ...state, loading: false, successCreate: false };
    case UPDATE_AUTOMATION_SETTINGS_REQ:
      return { ...state, loading: true };
    case UPDATE_AUTOMATION_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        successUpdate: true,
        automations: state.automations.map((automation) =>
          automation._id === action.payload._id ? action.payload : automation
        ),
      };
    case UPDATE_AUTOMATION_SETTINGS_RESET:
      return { ...state, loading: false, successUpdate: false };
    case UPDATE_AUTOMATION_SETTINGS_FAIL:
      return { ...state, loading: false, error: action.payload };
    case UPDATE_ACTIVATE_AUTOMATION_SETTINGS_REQ:
      return { ...state };
    case UPDATE_ACTIVATE_AUTOMATION_SETTINGS_SUCCESS:
      return {
        ...state,
        automations: state.automations.map((automation) =>
          automation._id === action.payload._id
            ? { ...automation, status: action.payload.status }
            : automation
        ),
      };
    case UPDATE_ACTIVATE_AUTOMATION_SETTINGS_FAIL:
      return { ...state, error: action.payload };
    case DELETE_AUTOMATION_SETTINGS_REQ:
      return { ...state, loading: true };
    case DELETE_AUTOMATION_SETTINGS_SUCCESS:
      return {
        loading: false,
        successDelete: true,
      };
    case DELETE_AUTOMATION_SETTINGS_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
